import '@zyf2e/zim-ecology/lib/pc.css';
import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import './style/element-variables.scss';
import './style/print/index.scss';
import router from './router';
import store from './store';
import { sync } from 'vuex-router-sync';
import './api';
import { checkPower } from './util';
import './lib/constant.js';
import filters from './filter';
import telescope from '@/plugins/telescope';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';
import directives from './directives';
import Copy from './directives/clipboard';
import '@zyf2e/video-service-ecology/lib/video.css';

dayjs.extend(advancedFormat);

window.Vue = Vue;
Object.entries(directives).forEach(([key, val]) => {
  Vue.directive(key, val);
});
Vue.prototype.$checkPower = checkPower;
Vue.use(Copy);
Vue.use(ElementUI);
Vue.use(telescope);

NProgress.configure({ showSpinner: false }); // NProgress Configuration
Vue.config.productionTip = false;
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
sync(store, router);
const VM = new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app');

Vue.prototype.$player = new Vue();

export default VM;
